export function isValidUrl(url: string) {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
}

export const parseGoogleMapsUrl = async (
  url: string,
  expandUrl: (url: string) => Promise<string>,
) => {
  if (!isValidUrl) {
    return null;
  }
  // Function to extract coordinates from a string
  const extractCoordinates = (str: string) => {
    const match = str.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
    return match
      ? { latitude: parseFloat(match[1]), longitude: parseFloat(match[2]) }
      : null;
  };

  // Check if it's a short URL
  if (url.includes("goo.gl")) {
    try {
      const finalUrl = await expandUrl(url);
      return extractCoordinates(finalUrl);
    } catch (error) {
      console.error("Error expanding short URL:", error);
      return null;
    }
  } else {
    // For full URLs, directly extract coordinates
    return extractCoordinates(url);
  }
};
